import * as Yup from "yup";

import { isValidPhone, yupPhoneTransform, PHONE_ERROR } from "../utils/phone";

const FreeTrialSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  email: Yup.string().email().required("Enter a valid e-mail address"),
  // Required at signup so a new owner never lands straight into the
  // phone-required gate. Normalised to E.164 on submit (see utils/phone.js).
  phoneNumber: Yup.string()
    .transform(yupPhoneTransform)
    .required("Mobile number is required")
    .test("valid-phone", PHONE_ERROR, (value) => !value || isValidPhone(value)),
  businessName: Yup.string().required("Company name is required"),
  address: Yup.string().required("Address is required"),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  industry: Yup.string().required("Industry is required"),
  zipcode: Yup.string().required("Postal code is required"),
  companySize: Yup.string().required("Company size is required"),
  termsAndConditions: Yup.boolean().oneOf(
    [true],
    "You must accept the terms and conditions",
  ),
});

export default FreeTrialSchema;
